module.exports = __webpack_public_path__ + "static/media/status-new.f3b468fc.svg";